<template>
  <div class="otherContract">
    <div class="otherContractTip">
      已绑定企业授权协议
    </div>
    <div v-if="isShowData" class="bindEnterprise_img">
      <img src="@/assets/images/nodata.png" alt="">
      <span>暂无数据</span>
    </div>
    <OtherContractList :otherContractData="otherContractData" v-if="otherContractData.length > 0" />
    <div v-if="isShowBtn" class="realNameAuth_btn realNameAuth_card" @click="bindReturn">返回</div>
  </div>
</template>

<script>

import OtherContractList from './otherContractList.vue';

export default {
  name: 'otherContract',
  components: {
    OtherContractList,
  },
  data() {
    return {
      isShowData: false,
      isShowBtn: false,
      otherContractData: [],
    };
  },
  mounted() {
    this.queryAllContract();
  },
  methods: {
    async queryAllContract() {
      const res = await this.$api.PublicPage.queryAllContract({
        contractType: '1', // 1-其他协议 ，2-订单协议
        name: '',
      });
      if (res.success) {
        this.otherContractData = res.data;
        if (res.data.length === 0) {
          this.isShowData = true;
        } else {
          this.isShowData = false;
        }
      } else {
        this.isShowData = true;
      }
      this.isShowBtn = true;
    },
    bindReturn() {
      this.$router.push(
        '/supermarket/v2/personalCenter',
      );
    },
  },
};
</script>
<style scoped>
.otherContractTip{
  height: 50px;
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1C2438;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 0 15px;
  background: #fff;
  position: relative;
}
.otherContractTip::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.bindEnterprise_img{
  width: 100%;
  height: 280px;
  overflow: hidden;
  margin-top: 30px;
}
.bindEnterprise_img img{
  width: 100%;
  height: 100%;
}
.bindEnterprise_img span {
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  letter-spacing: 0;
  text-align: center;
  margin-top: -90px;
}
.realNameAuth_btn {
  height: 44px;
  margin: 20px 16px;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.realNameAuth_card {
  background: #ff6538;
}
</style>
